/* eslint-disable import/prefer-default-export */
export const ANIMATION_DURATION = '5s'
